import { useTranslation } from 'react-i18next';
import { DataView } from 'src/components/DataView/DataView';
import { ResourceNameView } from 'src/components/ResourceNameView/ResourceNameView';
import { PartnerDto, ProductDto } from 'src/generated-api-client';
import { ProductOfferingTypeResourceStore } from 'src/stores/Resources/ProductOfferingTypeResourceStore';
import { CssColors } from 'src/styles/CssVariables';
import { JahezComissionType } from 'src/types/jahezComissionType';
import { NumberHelper } from 'src/utils/NumberHelper';
import styled from 'styled-components';

type ProductDetailsProps = {
    partner: PartnerDto;
    product: ProductDto;
};

export const ProductDetails = ({ product, partner }: ProductDetailsProps) => {
    const { t } = useTranslation();

    return (
        <StyledWrapper>
            <div className="field">
                <div className="field__label">
                    {t('App.Components.ProductDetails.JahezCommision')}:
                </div>
                <DataView
                    className="field__value"
                    formatValue={
                        partner.jahezComissionType ===
                        JahezComissionType.PERCENTAGE
                            ? 'percent'
                            : 'currency-sar'
                    }
                    value={
                        partner.jahezComissionType ===
                        JahezComissionType.PERCENTAGE
                            ? partner.jahezComissionPct
                            : partner.jahezComissionAmount
                    }
                />
            </div>
            <div className="field">
                <div className="field__label">
                    {t('App.Components.ProductDetails.Amount')}:
                </div>
                <div className="field__value">
                    SAR{' '}
                    {NumberHelper.formatThousandSeparator(product.minAmount!)} -{' '}
                    {NumberHelper.formatThousandSeparator(product.maxAmount!)}
                </div>
            </div>
            <div className="field">
                <div className="field__label">
                    {t('App.Components.ProductDetails.Term')}:
                </div>
                <div className="field__value">
                    {product.minTerms} - {product.maxTerms}
                </div>
            </div>
            <div className="field">
                <div className="field__label">
                    {t('App.Components.ProductDetails.MurabahaRate')}:
                </div>
                <div className="field__value">
                    {product.minMurabahaRatePct}% - {product.maxMurabahaRatePct}
                    %
                </div>
            </div>
            <div className="field">
                <div className="field__label">
                    {t('App.Components.ProductDetails.TypeOfOfferings')}:
                </div>
                <ResourceNameView
                    className="field__value"
                    resourceStore={ProductOfferingTypeResourceStore}
                    value={product.offeringTypes}
                />
            </div>
        </StyledWrapper>
    );
};

const StyledWrapper = styled.div`
    border-radius: 8px;
    background-color: ${CssColors.lightGray};
    padding: 12px;

    .field {
        display: flex;
        align-items: baseline;
    }

    .field__label {
        width: 150px;
        flex-basis: 150px;
        flex-shrink: 0;
        font-size: 14px;
        color: ${CssColors.gray};
    }

    .field__value {
        flex: 1;
        font-size: 14px !important;
        font-weight: 500;
        text-align: end;
    }
`;
